










































































































import Vue from "vue";
import _ from "lodash";
import { createNamespacedHelpers } from "vuex";
import TabbarBase from "@/components/TabbarBase.vue";
import { currentUser } from "@/api/my";
import { Gender } from "@/scripts/enums";
import config from "@/config";
import { Toast } from "vant";
import i18n from "@/locales/i18n";

const { mapGetters, mapState, mapActions } = createNamespacedHelpers("login");

export default Vue.extend({
    name: "My",
    components: { TabbarBase },
    data() {
        return {
            showDialog: false,
            name: "",
            phone: "",
            showDot: false,
            showArrow: false,
            gender: Gender.MALE,
            avatarUrl: "",
            showTcQrcode: config.LINK_TO_TC == "app"
        };
    },
    mounted() {
        if (this.loggedIn) {
            currentUser().then(resp => {
                if (resp.data) {
                    const userName = resp.data.data.name;
                    this.showArrow = _.isEmpty(userName);
                    this.name = userName || this.$t("my.nameEmptyTips");
                    this.phone = resp.data.data.phone;
                    this.gender = resp.data.data.gender;
                    this.avatarUrl = _.isEmpty(resp.data.data.avatarResource)
                        ? ""
                        : resp.data.data.avatarResource.thumbnailUrl;
                }
            });
        } else {
            const err = this.$route.query?.err;
            if (err) {
                Toast(i18n.t("" + err));
            }
        }
    },
    methods: {
        toLogin() {
            if (config.IDENTITY_LOGIN_ENABLED) {
                window.location.href = encodeURI(
                    config.INTERNAL_IDENTITY_URL +
                        "/login?service=" +
                        encodeURI(this.$constants.IDENTITY_CAS_PARAM_SERVICE)
                );
            } else {
                this.$router.push("/login");
            }
        },
        safeGo(path): string {
            return this.loggedIn ? path : "/login";
        },
        tcClick() {
            if (this.showTcQrcode) {
                this.showDialog = true;
            } else {
                this.redirectTcH5();
            }
        },
        redirectTcH5() {
            window.location.href = encodeURI(config.LINK_TO_TC_URL);
        },
        toMyInfo() {
            if (this.showArrow) {
                return this.$router.push(this.safeGo("/my/info"));
            }
        },
        toMyInfoWithoutArrow() {
            return this.$router.push(this.safeGo("/my/info"));
        },
        ...mapActions(["logout", "login"])
    },
    computed: {
        ...mapGetters(["loggedIn"]),
        ...mapState(["token"]),
        avatarImage(): string {
            return this.avatarUrl || require(`@/assets/default_avatar_${this.gender.toLowerCase()}.png`);
        }
    }
});
